import { Injectable } from '@angular/core';
import { AppConfigService } from '../config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CloudinaryService {

  constructor(private appConfigService: AppConfigService) { }

  /**
   * A partir de la ruta de imagen cruda que devuelve el backend, arma la URL optimizada para Cloudinary
   * (f_auto,q_auto:good/c_fit). Si la ruta cruda resuelve a la URL base del backend (o está vacía y
   * treatEmptyAsUnset está activo), devuelve el fallback indicado.
   */
  resolveImageUrl(rawPath: string, options?: { treatEmptyAsUnset?: boolean, fallback?: string }): string | undefined {
    // rawPath puede llegar undefined/null cuando el campo todavia no viene en la
    // respuesta del backend (ej. un campo nuevo en un endpoint no redeployado
    // todavia). new URL(undefined, base) lo convierte al string literal "undefined"
    // y lo mete como segmento de la ruta, así que se normaliza antes de todo.
    rawPath = rawPath || '';

    const environment = this.appConfigService.getEnvironment();
    const environmenturl = this.appConfigService.getEnvironmentUrl();

    let imgenurl: string = new URL(rawPath, environmenturl).toString();
    const esUrlBase = (environment.endpoint + environment.endpointversion) === imgenurl;
    const esVacioIgnorable = !!options?.treatEmptyAsUnset && rawPath === '';

    if (esUrlBase || esVacioIgnorable) {
      return options?.fallback;
    }

    const imgSplit = imgenurl.split('/');
    const imgTransformation = 'f_auto,q_auto:good/c_fit';

    // Si rawPath ya es una URL de Cloudinary con su propia transformación aplicada
    // (segmento 6 no es la versión "vNNNN"), no insertamos una segunda transformación
    // encima: eso rompía la URL (quedaba .../upload/f_auto,.../f_auto,.../v.../img.png => 404).
    const esCloudinaryUpload = imgenurl.includes('res.cloudinary.com') && imgSplit[5] === 'upload';
    const siguienteEsVersion = /^v\d+$/.test(imgSplit[6] || '');
    if (esCloudinaryUpload && !siguienteEsVersion) {
      return imgenurl;
    }

    return imgSplit.slice(0, 6).join('/') + '/' + imgTransformation + '/' + imgSplit.slice(6).join('/');
  }
}
